import React from 'react';
// Icons
import { IoIosMore as MenuIcon } from 'react-icons/io';
// Components
import Popover from './Popover';

const Menu = ({ isOpen = false, actions = [], onClick = () => null }) => (
  <div className="menu">
    <MenuIcon onClick={onClick} />
    {
      isOpen &&
      <Popover
        title="List Actions"
        onClickOutside={onClick}
      >
        {
          actions.map((list, i) => (
            <div key={i}>
              <ul className="menu-actions">
                {
                  list.map((action, j) => (
                    <li
                      className="menu-action"
                      key={j}
                      onClick={action.onClick}
                    >
                      <p>{action.title}</p>
                    </li>
                  ))
                }
              </ul>
              <hr className="divider" />
            </div>
          ))
        }
      </Popover>
    }
  </div>
);

export default Menu;
